import React, { useEffect, useState } from "react";
import { axInstBasic } from "./Service/Service";

const WatermarkBlock = ({ children, className = "" }) => {
  return (
    <div
      className={
        "fixed top-1/2 -translate-y-1/2 pointer-events-none select-none whitespace-nowrap z-[9993] text-2xl font-bold text-black/10 " +
        className
      }
      aria-hidden="true"
    >
      <div className="flex flex-col items-center gap-1">
        {children}
      </div>
    </div>
  );
};

const WaterMark = () => {
  const [userName, setUserName] = useState("");
  const [watermarkData, setWatermarkData] = useState("");
  const [currentTime, setCurrentTime] = useState(new Date());

  const today = new Date();
  const token = localStorage.getItem("token");
  const options = { day: "numeric", month: "numeric", year: "numeric" };
  const formattedDate = today.toLocaleDateString(undefined, options);

  const fetchWatermark = async (token) => {
    try {
      const res = await axInstBasic.post(
        `${process.env.REACT_APP_API_URL}waterMark`,
        { token }
      );
      return res.data;
    } catch (error) {
      console.error("Watermark API Error:", error);
      throw error;
    }
  };

  const getWatermark = async () => {
    try {
      const data = await fetchWatermark(token);
      setWatermarkData(data);
    } catch (err) {
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const timerId = setInterval(() => setCurrentTime(new Date()), 1000);

    const storedName = localStorage.getItem("username");
    if (storedName) setUserName(storedName);

    if (token) getWatermark();
    return () => clearInterval(timerId);
  }, []); // keep empty so it runs on mount only

  const displayName = watermarkData?.name || userName || "Watermark";
  const userIp = watermarkData?.user_ip || "";

  return (
    <>
      {/* LEFT watermark: vertically centered, slightly rotated (optional) */}
      <WatermarkBlock className="left-12 translate-x-48 -rotate-0 mt-12">
        <div className="text-center leading-none tracking-wide">
          <div>{displayName}</div>
          {userIp && <div className="text-sm">{userIp}</div>}
        </div>
        <div className="flex gap-3 text-sm mt-1">
          <span>{currentTime.toLocaleTimeString()}</span>
          <span>{formattedDate}</span>
        </div>
      </WatermarkBlock>

      {/* RIGHT watermark: vertically centered on the right */}
      <WatermarkBlock className="right-12 -translate-x-48  -rotate-0 mt-12">
        <div className="text-center leading-none tracking-wide">
          <div>{displayName}</div>
          {userIp && <div className="text-sm">{userIp}</div>}
        </div>
        <div className="flex gap-3 text-sm mt-1">
          <span>{currentTime.toLocaleTimeString()}</span>
          <span>{formattedDate}</span>
        </div>
      </WatermarkBlock>
    </>
  );
};

export default WaterMark;
